import {useRef, useState} from 'react';
import { toast } from 'react-toastify';

// import classes from './MealItemForm.module.css';
import Input from '../Input';

const MealItemForm = (props) => {
	const [amountIsValid, setAmountIsValid] = useState(true);
	const amountInputRef = useRef();

	const submitHandler = (event) => {
		event.preventDefault();
		const enteredAmount = amountInputRef.current.value;
		const enteredAmountNumber = +enteredAmount;

		if (enteredAmount.trim().length === 0
			
		) {
			setAmountIsValid(false);
			return;
		}
		props.onAddToCart(enteredAmountNumber);
		toast.success(`Added to cart: ${enteredAmount} item(s)`)
	};

	return (
		<form style={{display: "flex",justifyContent: "space-between",alignContent: "center",alignItems: "center"}} onSubmit = {submitHandler} >
			<Input
				ref = {amountInputRef}
				label = "Amount" 
				input = {{
					id: 'amount_' + props.id,
					type: 'number',
					min: '1',
					max: '5',
					step: '1',
					defaultValue: '1'
				}} 
			/>												
			<i onClick={submitHandler} style={{fontSize:18,cursor:'pointer'}} className="uil uil-shopping-cart-alt" />
			{/* {!amountIsValid && <p>Please enter a valid amount (1-5).</p>} */}
		</form>
	);
};

export default MealItemForm;